'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import UITextToolbarSplitSelect from '../editor/UITextToolbarSplitSelect';
import { omit } from '../../utils/iterables';
import { jsx as _jsx } from "react/jsx-runtime";
export default class ListMenu extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }
  handleChange({
    target: {
      value
    }
  }) {
    this.props.onListTypeChange(value);
  }
  render() {
    const props = omit(Object.keys(ListMenu.propTypes), this.props);
    return /*#__PURE__*/_jsx(UITextToolbarSplitSelect, Object.assign({}, props, {
      onButtonClick: this.props.onClick,
      onChange: this.handleChange
    }));
  }
}
ListMenu.propTypes = {
  onListTypeChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired
};